

const Contant = "https://tiendungfinance.com.vn/"

export default Contant